import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { x } from '@xstyled/styled-components';
import { colors } from '../theme/colors';
import { useRatingTranslation } from './hooks/use-rating-translation';
export function RatingFormFacesLabel(_ref) {
  var formType = _ref.formType;
  var getTranslation = useRatingTranslation(formType);
  return /*#__PURE__*/_jsxs(x.div, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    w: "100%",
    mt: "16px",
    children: [/*#__PURE__*/_jsx(x.div, {
      fontWeight: "500",
      fontSize: "12px",
      lineHeight: "11px",
      color: colors.lightGray,
      w: "80px",
      children: getTranslation('VERY_BAD')
    }), /*#__PURE__*/_jsx(x.div, {
      fontWeight: "500",
      fontSize: "12px",
      lineHeight: "11px",
      color: colors.lightGray,
      w: "80px",
      textAlign: "right",
      children: getTranslation('VERY_GOOD')
    })]
  });
}